import { Component, OnInit } from '@angular/core';
import { dxHtmlEditorToolbar, dxHtmlEditorToolbarItem } from 'devextreme/ui/html_editor';
import { ApiClientService } from '../../services/api-client.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-cijene-ino',
  templateUrl: './cijene-ino.component.html',
  styleUrls: ['./cijene-ino.component.scss']
})
export class CijeneInoComponent implements OnInit {

  constructor(private apiClient: ApiClientService, private userService: UserService) {
    this.isReadonly = !this.userService.isUserAgroModerator();
  }

  async ngOnInit(): Promise<void> {
    this.content = await this.apiClient.cijeneInoGET();
  }
  content: string = '';
  isReadonly = true;

  formats: [
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'align',
    'list',
    'link',
    'table'
  ];

  toolbar: dxHtmlEditorToolbar = {
    items: [
      'undo',
      'redo',
      'separator',
      {
        name: 'font',
        acceptedValues: [
          'Arial',
          'Times New Roman',
          'Courier New',
          'Georgia',
          'Verdana'
        ]
      },
      {
        name: 'size',
        acceptedValues: [
          '8pt',
          '10pt',
          '11pt',
          '12pt',
          '14pt',
          '16pt',
          '18pt',
          '24pt',
          '32pt'
        ]
      },
      'separator',
      {
        name: 'color'
      },
      {
        name: 'background'
      },
      'separator',
      'bold',
      'italic',
      'underline',
      'strike',
      'separator',
      'alignLeft',
      'alignCenter',
      'alignRight',
      'alignJustify',
      'separator',
      'orderedList',
      'bulletList',
      'separator',
      'insertTable',
      'insertRowAbove',
      'insertRowBelow',
      'insertColumnLeft',
      'insertColumnRight',
      'deleteRow',
      'deleteColumn',
      'deleteTable',
      'separator',
      'link',
      'separator',
      'clear'
    ]
  };

  imageUploadConfig = {
    tabs: ['file', 'url'],
    fileUploadMode: 'base64' // quick setup, no backend needed
  };

  async save() {
    await this.apiClient.cijeneInoPOST(this.content);
  }

  clear() {
    this.content = '';
  }
}
